export default theme => ({
  modalMainContainer: {
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    color: theme.palette.background.paper,
    position: 'absolute',
    width: 500
  },
  cardHeader: {
    padding: theme.spacing(2, 3)
  },
  cardHeaderTitle: {
    fontSize: 20
  },
  cardContent: {
    padding: theme.spacing(1, 3, 5)
  },
  cardActions: {
    padding: theme.spacing(1.5, 3),
    justifyContent: 'flex-end'
  },
  cardActionsSpacing: {
    '& > :not(:first-child)': {
      marginLeft: theme.spacing(2)
    }
  }
});
